<template>
  <router-view />
</template>

<script>
export default {
  name: "CatalogoAccesos",
};
</script>

<style scoped></style>
